module.exports = __webpack_public_path__ + "img/paci_ar_1.0481501c.png";